import { useEffect, useState, useContext } from 'react';

import moment from 'moment';

import { LayoutContext } from '../../baseLayout/provider';

import SvgIcon from '@/components/SvgIcon';
import Utils from '@/utils/Utils';

const PlusInfoPop = ({ plusInfo }) => {
  const { resourceData } = useContext(LayoutContext);
  const { projectConfigVO } = resourceData;

  const dataList = [
    {
      id: 1,
      icon: 'plus-1-new',
      title: '成长福利',
      tip: '大额补贴',
      class: 'w-[29px] h-[28px]',
    },
    {
      id: 2,
      icon: 'plus-2-new',
      title: '专属折扣',
      tip: '热销爆款',
      class: 'w-[31px] h-[27px]',
    },
    {
      id: 3,
      icon: 'plus-3-new',
      title: '运费抵扣券',
      tip: '无门槛包邮',
      class: 'w-[33px] h-[25px]',
    },
    {
      id: 4,
      icon: 'plus-4-new',
      title: '商品优惠券',
      tip: '尖货折上折',
      class: 'w-[31px] h-[32px]',
    },
    {
      id: 5,
      icon: 'plus-5-new',
      title: '嘉立创集团券',
      tip: '6大业务线',
      class: 'w-[30px] h-[32px]',
    },
    {
      id: 6,
      icon: 'plus-6-new',
      title: '品牌折扣券',
      tip: '大牌齐钜惠',
      class: 'w-[35px] h-[29px]',
    },
    {
      id: 7,
      icon: 'plus-7-new',
      title: 'BOM折扣',
      tip: '1.3倍BOM折扣',
      class: 'w-[34px] h-[34px]',
    },
    {
      id: 8,
      icon: 'plus-8-new',
      title: '兑换折扣',
      tip: '低价兑好物',
      class: 'w-[31px] h-[32px]',
    },
    {
      id: 9,
      icon: 'plus-9-new',
      title: '商务专员',
      tip: '享优先对接',
      class: 'w-[30px] h-[30px]',
    },
    {
      id: 10,
      icon: 'plus-10-new',
      title: '1.3倍积分',
      tip: '积分当钱花',
      class: 'w-[30px] h-[29px]',
    },
  ];

  const [text, setText] = useState('立即开通PLUS会员享受以下权益');
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (plusInfo?.isNeverOpen) {
      setText('立即开通PLUS会员享受以下权益');
    } else if (plusInfo?.isPlusMember) {
      const date = moment(plusInfo?.validDate).format('yyyy年MM月DD日');
      setText(`您的PLUS会员将于${date}到期`);
    } else {
      setText('您的PLUS会员已到期');
    }
    setIsOpen(!plusInfo?.isNeverOpen);
  }, [plusInfo]);

  if (!plusInfo) {
    return <>loading...</>;
  }

  return (
    <section className="w-[436px] pt-[16px]" data-spm="hd">
      <p className="text-right">
        <a
          href={`${projectConfigVO?.lcscMemberUrl}/member/center.html`}
          className="pr-[16px] border-r-[#E4E4E4] border-r-[1px] border-solid"
          aria-label="账户信息"
          target="_blank"
          data-spm="zh"
        >
          账户信息
        </a>
        <span
          className="px-[16px] cursor-pointer"
          onClick={() => {
            Utils.logout();
          }}
        >
          退出
        </span>
      </p>
      <p className="mt-[16px] flex h-[40px] w-[436px] items-center justify-between bg-[#EDF9FF] px-[20px] text-[14px]">
        <span className="text-black">{text}</span>
        {isOpen ? (
          <a
            className="w-[72px] h-[24px] bg-lcBlue text-center text-white rounded-[4px] hover:text-white"
            href={`${projectConfigVO?.lcscActivityUrl}/plusIndex.html`}
            target="_blank"
            data-spm="xf"
            key="xf"
          >
            立即续费
          </a>
        ) : (
          <a
            className="w-[72px] h-[24px] bg-lcBlue text-center text-white rounded-[4px] hover:text-white"
            href={`${projectConfigVO?.lcscActivityUrl}/plusIndex.html`}
            target="_blank"
            data-spm="kt"
            key="kt"
          >
            立即开通
          </a>
        )}
      </p>
      <ul className="px-[20px] pt-[15px] flex flex-wrap justify-between">
        {dataList.map((data) => (
          <li key={data.id} className="mb-[16px] w-[72px] text-center">
            <div className="flex item-center justify-center w-[72px] h-[35px]">
              <SvgIcon app="common" iconName={data.icon} className={`m-auto ${data.class}`} />
            </div>
            <section className="mt-[4px]">
              <p className="text-[12px] text-center leading-[17px]">{data.title}</p>
              <p className="text-[10px] text-center text-[#C99063] leading-[14px]">{data.tip}</p>
            </section>
          </li>
        ))}
        <li className="w-[72px]"></li>
      </ul>
    </section>
  );
};

export default PlusInfoPop;
